import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { OneTimePaySetup } from '@amfam/billing/one-time-pay/feature';
import { ButtonProps } from '@amfam/shared/models';
import { CopyService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'ds-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaymentDetailsComponent implements OnInit {
  @Input() data: OneTimePaySetup;
  @Input() riskDescription: string;
  @Input() isConfirmationPage = false;
  @Input() isRecurringPage = false;
  @Input() amountSubheading: string;
  @Input() showActionLink = false;

  recurringSubtext = '';
  headingHeight = '';
  risks: string[];
  print: ButtonProps[];
  regex = /,/g;
  constructor(
    private store: Store,
    private copyService: CopyService
  ) {}

  ngOnInit(): void {
    this.recurringSubtext = this.copyService.getCopy('billing.recurring.recurringSubtext');
    this.risks = this.riskDescription.split(';');

    this.print = [
      {
        name: 'Print',
        iconClass: 'icon-print',
        clickEvent: () => {
          print();
        }
      }
    ];
  }
}
